import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { rokubColumn } from "Constants/TableColumns";
import { Grid } from "@material-ui/core";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import cellEditFactory from "react-bootstrap-table2-editor";
import { read } from "Helpers/LocalStorage";
import { disableRokub, EditPriceRokub, GetAllRokub, changeRokubSearch } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Search from "Assets/svg/icon/search.svg";
import Input from "Components/Input/Input";
import { ReactSVG } from "react-svg";
import { useTranslation } from 'react-i18next';
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";

function TblRokub() {
  const { t } = useTranslation();
  const { rokubData, rokubDataPagination, rokubDataSearch, rtlLayout } = useSelector(
    (state) => ({
      rokubData: state.rokub.rokubData,
      rokubDataPagination: state.rokub.rokubDataPagination,
      rokubDataSearch: state.rokub.rokubDataSearch,
      rtlLayout: state.settings.rtlLayout,
    })
  );
  const [sizePerPage, setSizePerPage] = useState(rokubDataPagination.Limit);
  const [currentPage, setCurrentPage] = useState(rokubDataPagination.Page);
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState(rokubData);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (rokubData) {
      const isAdmin = read("StypeU") === "1";
      const isRecordRegisteredByAdmin = rokubData?.IsG;
      const isUserHasAccessPrice2 = read("rokubRules").accessPrice2;
      const updateRokubColumn = [...rokubColumn];
      const isAllAdmin = rokubData.every((item) => item.IsG);
      updateRokubColumn[6].hidden = isAdmin || (isUserHasAccessPrice2 === false && isRecordRegisteredByAdmin) || (isAllAdmin && isUserHasAccessPrice2 === false);
      updateRokubColumn[2].align = rtlLayout ? "right" : "left";
      updateRokubColumn[2].headerAlign= rtlLayout ? "right" : "left";
      setColumns(updateRokubColumn);
    }
    return () => setColumns(null);
  }, [rokubData]);

  useEffect(() => {
    if (rokubData) {
      setTblData(rokubData);
      setTotal(rokubDataPagination.Total);
    }
  }, [rokubData, rokubDataPagination]);

  const BeforeSaveCell = async (oldValue, newValue, row, column, done) => {
    if (column.dataField === "Disable") {
      const updateNewValue = JSON.parse(newValue);
      if (oldValue !== updateNewValue) {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: Number(row.Id),
            Disable: updateNewValue,
          };
          await dispatch(disableRokub(data));
          //todo seo
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: rokubDataSearch?.Name,
            Limit: rokubDataPagination.Limit,
            Page: rokubDataPagination.Page,
          };
          await dispatch(GetAllRokub(params));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      }
    }
    if (column.dataField === "GroupPrice" || column.dataField === "UserPrice") {
      const newPrice = newValue.replaceAll(",", "");
      const oldPrice = oldValue.replaceAll(",", "");
      if (parseFloat(newPrice) !== parseFloat(oldPrice)) {
        try {
          setLoading(true);
          const data = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            Price: +newPrice,
            IdRokob: row.Id,
          };
          await dispatch(EditPriceRokub(data));
          //todo seo
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: rokubDataSearch?.Name,
            Limit: rokubDataPagination.Limit,
            Page: rokubDataPagination.Page,
          };
          await dispatch(GetAllRokub(params));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      } else {
        done(false);
      }
    }
  };

  const setValue = (name, value) => {
    dispatch(changeRokubSearch({ Name: value }));
  };

  const onSearch = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Limit: sizePerPage,
        Page: 1,
        Name: convertToEnglishNumber(rokubDataSearch.Name),
      };
      await dispatch(GetAllRokub(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    dispatch(changeRokubSearch({ Name: "" }));
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Limit: sizePerPage,
        Page: 1,
      };
      await dispatch(GetAllRokub(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: sizePerPage,
          Page: page,
          Name: rokubDataSearch?.Name,
        };
        await dispatch(GetAllRokub(params));
        setCurrentPage(page);
        setSizePerPage(sizePerPage);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  };

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <Grid container spacing={2} className="mb-1">
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={rokubDataSearch ? rokubDataSearch?.Name : ""}
            placeholder={t('nameSearch')}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
      </Grid>
      {columns && (
        <RemoteTable
          data={tblData}
          columns={columns}
          loading={loading}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
          cellEdit={cellEditFactory({
            mode: "click",
            blurToSave: true,
            beforeSaveCell: (oldValue, newValue, row, column, done) =>
              BeforeSaveCell(oldValue, newValue, row, column, done),
          })}
          title={<Translator id="list_rokob" />}
        />
      )}
    </Fragment>
  );
}

export default TblRokub;
